import React, { useEffect, useState } from 'react';
import { get_ListeType } from '../api/type';
import { Select } from 'antd';

const {Option} = Select


const ListeType = ({onchange, valeur}) => {

    const [ListeType, setListeType] = useState([])

    useEffect(() => {
        fetchType()
      
    }, []);

    const fetchType = async () => {
        const res = await get_ListeType()
        if (res.status === "success") {
            setListeType(res.data)
        }
    }


    return (
        <div>
            <Select
                showSearch
                size = 'medium'
                style = {{
                    width: '100%',
                    textAlign: 'center'
                }}
                onChange={(value) => {
                    if(onchange) onchange(value)
                }}
                value={valeur && valeur !== 0 ? valeur : null} 
                placeholder="Choisir type de camion"
            >
                {
                    ListeType && ListeType.map(item => {
                        return(
                            <Option key={item['id']} value={item['id']}>{item.nom}</Option>
                        )
                    })
                }
            </Select>
        </div>
    );
}

export default ListeType;
